__turbopack_context__.v({
  "badge": "ParagraphTwoModelsCompare-module__0s_EBW__badge",
  "card": "ParagraphTwoModelsCompare-module__0s_EBW__card",
  "cardHeader": "ParagraphTwoModelsCompare-module__0s_EBW__cardHeader",
  "cardMain": "ParagraphTwoModelsCompare-module__0s_EBW__cardMain",
  "cardTitle": "ParagraphTwoModelsCompare-module__0s_EBW__cardTitle",
  "checkIcon": "ParagraphTwoModelsCompare-module__0s_EBW__checkIcon",
  "desc": "ParagraphTwoModelsCompare-module__0s_EBW__desc",
  "eyebrow": "ParagraphTwoModelsCompare-module__0s_EBW__eyebrow",
  "grid": "ParagraphTwoModelsCompare-module__0s_EBW__grid",
  "header": "ParagraphTwoModelsCompare-module__0s_EBW__header",
  "item": "ParagraphTwoModelsCompare-module__0s_EBW__item",
  "items": "ParagraphTwoModelsCompare-module__0s_EBW__items",
  "lead": "ParagraphTwoModelsCompare-module__0s_EBW__lead",
  "section": "ParagraphTwoModelsCompare-module__0s_EBW__section",
  "title": "ParagraphTwoModelsCompare-module__0s_EBW__title",
});
